import React from 'react'
import config from '../../config'
import { Auth0Provider } from '@auth0/auth0-react'

const AuthProvider = ({ children }) => (
    <Auth0Provider
        domain={config.authDomain}
        clientId={config.authClientId}
        redirectUri={window.location.origin}
        audience={config.authAudience}
        scope="read:current_user"
    >
        {children}
    </Auth0Provider>
)

export default AuthProvider
